import { Grid, Skeleton, Button, List, Separator, Divider } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePersonPageParams } from '../../personPageRouteUtil'
import useQualityIndicatorFlag from '../../../data-service/useQualityIndicatorFlag'
import PersonQualityScoreButtonSkeleton from '../../../common/PersonQualityScoreButtonSkeleton'
import SectionCardSkeleton from '../../components/section-card/SectionCardSkeleton'

type Props = {
  isSingleCardPage?: boolean
}

export default function ResearchHelpCardSkeleton({ isSingleCardPage = true }: Props): JSX.Element {
  const [t] = useTranslation()
  const { pid } = usePersonPageParams('partial')
  const { data: qualityIndicatorFlag } = useQualityIndicatorFlag()
  const showQualityScore = !!qualityIndicatorFlag?.isOn

  return (
    <Grid gutters="nano">
      <SectionCardSkeleton isSingleCardPage={isSingleCardPage} heading={t('tree-person.research-help.label')}>
        {showQualityScore && (
          <>
            {/* eslint-disable-next-line test-selectors/button -- NA */}
            <PersonQualityScoreButtonSkeleton variant="split" />
            <Separator size="nano" />
            <Divider />
            <Separator size="xs" />
          </>
        )}
        <List>
          <Skeleton.ListItem hasSecondLine hasIcon dense />
          <Skeleton.ListItem hasSecondLine hasIcon dense />
          <Skeleton.ListItem hasSecondLine hasIcon dense />
        </List>
        {pid && (
          <Button data-testid="research-help-show-all" to={`/research-help/${pid}`}>
            {t('tree-person.show-all.action')}
          </Button>
        )}
      </SectionCardSkeleton>
    </Grid>
  )
}
